import { Tabs } from '@mantine/core';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  value: string;
};

export default function Tab({ children, value }: Props) {
  return (
    <Tabs.Tab value={value} unstyled>
      {children}
    </Tabs.Tab>
  );
}
